export const MCP_SERVER_INVOKE_TOOL = 'mcp/server/invokeTool';
